<script setup lang="ts" generic="T extends string">
import { ref, watch, onMounted, watchEffect } from "vue";
import { getCSSVar, injectStyle } from "@zyzgroup/core-web";
import SVGDown from "../svg/SVGDown.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { SVGDown }
});

const props = withDefaults(
  defineProps<{
    options: Array<T>;
    initIndex?: number;
    fontSize?: string;
    bgColor?: string;
    hoverColor?: string;
    selectedColor?: string;
    fontColor?: string;
    duration?: number;
  }>(),
  {
    initIndex: 0,
    fontSize: "16px",
    bgColor: "#ffffff",
    hoverColor: "#f5f5f5",
    selectedColor: getCSSVar("--yz-xg-blue", "#5a82f0"),
    fontColor: "#333333",
    duration: 300
  }
);

const emits = defineEmits<{
  (event: "change", index: number, value: T): void;
}>();

onMounted(() => {
  injectStyle(`
    :root {
      --select-option-bg-color: ${props.bgColor};
      --select-option-bg-color-hover: ${props.hoverColor};
    }
  `);
});

const open = ref(false);

const selectedIndex = ref(props.initIndex);

watch(selectedIndex, function () {
  emits("change", selectedIndex.value, props.options[selectedIndex.value]);
});

function click() {
  open.value = !open.value;
}
function change(index: number) {
  selectedIndex.value = index;
  open.value = false;
}

const rotateSvg = ref("rotate(-180deg)");
watchEffect(() => {
  rotateSvg.value = open.value ? "rotate(0deg)" : "rotate(-90deg)";
});
</script>

<template>
  <div
    class="select-absolute"
    :style="{ fontSize: props.fontSize, backgroundColor: props.bgColor }"
  >
    <div
      class="select-absolute-button"
      @click="click"
    >
      <slot
        name="button"
        :selectedIndex="selectedIndex"
      >
        <div class="button-default">
          <div class="truncate">{{ options[selectedIndex] }}</div>
          <SVGDown
            class="icon-down"
            width="20px"
            :style="{
              transition: `transform ${props.duration}ms ease-in-out`,
              transform: rotateSvg
            }"
          ></SVGDown>
        </div>
      </slot>
    </div>

    <div
      class="options"
      :style="{
        maxHeight: open ? '200px' : 0,
        transition: `all ${props.duration}ms ease-in-out`,
        borderTop: `${open ? 1 : 0}px solid #e6e6e6`
      }"
    >
      <div
        @click="change(index)"
        class="option"
        v-for="(option, index) in options"
        :key="index"
        :value="index"
      >
        <slot
          :item="option"
          :index="index"
        >
          <div
            class="option-default"
            :style="{
              color:
                selectedIndex == index ? props.selectedColor : props.fontColor
            }"
          >
            {{ option }}
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.select-absolute {
  display: block;
  position: relative;
  width: 100%;
}
.select-absolute-button {
  overflow: hidden;
}
.button-default {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 15px;
  height: 44px;
  line-height: 44px;
  /*
  height: 32px;
  line-height: 32px;
  margin: 10px 15px;
  border: 1px solid #e6e6e6;
  background-color: #f5f5f5;
  border-radius: 4px;
  */
}
.icon-down {
  flex: 0 0 auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  word-break: break-all;
}
.options {
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  z-index: 99;
  width: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
  box-sizing: border-box;
}
/* scroll bar start */
.options::-webkit-scrollbar {
  /* 隐藏默认的滚动条 */
  -webkit-appearance: none;
}
.options::-webkit-scrollbar:vertical {
  width: 2px;
}
/*
.options::-webkit-scrollbar:horizontal{
	height: 2px;
}
*/
.options::-webkit-scrollbar-track {
  background-color: var(--select-option-bg-color);
}
/*
.options::-webkit-scrollbar-track-piece {
  width: 2px;
}
*/
.options::-webkit-scrollbar-thumb {
  /* 滚动条的其他样式定制，注意，这个一定也要定制，否则就是一个透明的滚动条 */
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.3);
}
/* scroll bar end */
.option {
  cursor: pointer;
}
.option-default {
  padding: 14px 15px;
  line-height: 1;
  background-color: var(--select-option-bg-color);
}
.option-default:hover {
  background-color: var(--select-option-bg-color-hover);
}
</style>
